
import { FileText, CheckCircle, Shield } from 'lucide-react';

export const HowItWorksSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4 text-emergency-700">Simple, Fast, Personalized</h2>
          <p className="text-lg text-muted-foreground">Our process makes emergency planning accessible for everyone</p>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-12 mb-16">
          <div className="lg:w-1/2">
            <img 
              src="/lovable-uploads/29a16391-124b-4ae8-b08f-926ceee2e77e.png" 
              alt="Family walking together on a path at sunset" 
              className="rounded-xl shadow-md w-full h-auto object-cover"
            />
          </div>
          
          <div className="lg:w-1/2 flex flex-col justify-center">
            <h3 className="text-2xl font-bold mb-4 text-emergency-700">Why Emergency Planning Matters</h3>
            <p className="text-lg text-muted-foreground mb-6">
              Studies show that households with emergency plans are significantly more likely to survive disasters without injury or property loss.
              Our platform makes creating these life-saving plans easier than ever before.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <CheckCircle size={20} className="text-emergency-600 mt-1 mr-2 flex-shrink-0" />
                <span>Reduce anxiety about potential emergencies</span>
              </li>
              <li className="flex items-start">
                <CheckCircle size={20} className="text-emergency-600 mt-1 mr-2 flex-shrink-0" />
                <span>Create clear protocols for your entire household</span>
              </li>
              <li className="flex items-start">
                <CheckCircle size={20} className="text-emergency-600 mt-1 mr-2 flex-shrink-0" />
                <span>Identify and address safety considerations</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center p-6">
            <div className="w-16 h-16 rounded-full bg-emergency-100 flex items-center justify-center mb-6 mx-auto relative">
              <FileText size={32} className="text-emergency-600" />
              <span className="absolute -right-2 -top-2 w-8 h-8 bg-emergency-600 text-white rounded-full flex items-center justify-center font-bold">1</span>
            </div>
            <h3 className="font-bold text-xl mb-3">Answer Questions</h3>
            <p className="text-muted-foreground">Answer questions about your home, family, and specific needs in a simple, conversational format</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 rounded-full bg-emergency-100 flex items-center justify-center mb-6 mx-auto relative">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emergency-600">
                <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                <path d="M12 12v9" />
                <path d="m16 16-4-4-4 4" />
              </svg>
              <span className="absolute -right-2 -top-2 w-8 h-8 bg-emergency-600 text-white rounded-full flex items-center justify-center font-bold">2</span>
            </div>
            <h3 className="font-bold text-xl mb-3">Upload Photos</h3>
            <p className="text-muted-foreground">Upload photos of your property to help identify potential hazards or vulnerabilities</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 rounded-full bg-emergency-100 flex items-center justify-center mb-6 mx-auto relative">
              <CheckCircle size={32} className="text-emergency-600" />
              <span className="absolute -right-2 -top-2 w-8 h-8 bg-emergency-600 text-white rounded-full flex items-center justify-center font-bold">3</span>
            </div>
            <h3 className="font-bold text-xl mb-3">Receive Plan</h3>
            <p className="text-muted-foreground">Receive your customized emergency preparedness plan within minutes</p>
          </div>
          
          <div className="text-center p-6">
            <div className="w-16 h-16 rounded-full bg-emergency-100 flex items-center justify-center mb-6 mx-auto relative">
              <Shield size={32} className="text-emergency-600" />
              <span className="absolute -right-2 -top-2 w-8 h-8 bg-emergency-600 text-white rounded-full flex items-center justify-center font-bold">4</span>
            </div>
            <h3 className="font-bold text-xl mb-3">Implement</h3>
            <p className="text-muted-foreground">Implement your plan with confidence, knowing it's designed for your specific situation</p>
          </div>
        </div>
      </div>
    </section>
  );
};
